// Lightweight, self-contained slider for the Collection list section.
// Wires the prev/next arrows to a horizontally scroll-snapping track and
// keeps the buttons' disabled state in sync with the scroll position.
class CollectionListSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-cl-track]');
    if (!this.track) return;

    this.prevBtn = this.querySelector('[data-cl-prev]');
    this.nextBtn = this.querySelector('[data-cl-next]');

    this._onScroll = () => this.updateButtons();

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.step(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.step(1));
    this.track.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll);

    this.updateButtons();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onScroll);
  }

  // Scroll by one card (card width + gap) in the given direction.
  step(direction) {
    const item = this.track.querySelector('[data-cl-item]');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const amount = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
    this.track.scrollBy({ left: direction * amount, behavior: 'smooth' });
  }

  updateButtons() {
    if (!this.prevBtn && !this.nextBtn) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
    const x = this.track.scrollLeft;
    const overflows = this.track.scrollWidth > this.track.clientWidth + 2;
    if (this.prevBtn) this.prevBtn.disabled = x <= 0;
    if (this.nextBtn) this.nextBtn.disabled = !overflows || x >= maxScroll;
  }
}

if (!customElements.get('collection-list-slider')) {
  customElements.define('collection-list-slider', CollectionListSlider);
}
